import { render, staticRenderFns } from "./footer-cmp.vue?vue&type=template&id=11078e0c&scoped=true"
import script from "./footer-cmp.vue?vue&type=script&lang=js"
export * from "./footer-cmp.vue?vue&type=script&lang=js"
import style0 from "./footer-cmp.vue?vue&type=style&index=0&id=11078e0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11078e0c",
  null
  
)

export default component.exports